import React, { useState } from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import { FormControl, Select, MenuItem, Button, InputLabel } from '@material-ui/core';
import { Modal, Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  paper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'left',
  },
  formControl: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    minWidth: 200,
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

export default function CreatePromo(props) {
  const { t } = useTranslation();
  const classes = useStyles();
  const { onetimeArray, setOnetimeID, langs, ...rest } = props;
  const [id, setId] = useState(null);
  const [error, setError] = useState('');

  const handleChange = async (event) => {
    setError('');
    setId(event.target.value);
  };
  const onSubmit = async (event) => {
    if (id == null) {
      setError('Please select one product');
    } else {
      setOnetimeID(id);
      props.onHide();
    }
  };

  return (
    <Modal className="modal-w" {...rest} centered size="md">
      <Modal.Header closeButton className="select-product-modal">
        <Modal.Title id="contained-modal-title-vcenter" style={{ fontSize: '1.2rem' }}>
          {t(`Select a product for your one time promotion`)}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="modal-body">
        <Container component="main">
          <CssBaseline />
          <Row>
            <Col xs={7}>
              <FormControl className={classes.formControl}>
                <InputLabel id="select-plano">{t('Product selection')}</InputLabel>
                <Select
                  fullWidth
                  labelId="select-plano"
                  id="select-plano"
                  value={id}
                  onChange={handleChange}
                  style={{ marginBottom: '10px' }}
                >
                  {onetimeArray.map((m) => {
                    return (
                      <MenuItem key={m._id} value={m}>
                        {m.title[langs]}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </Col>
            <Col xs={5}>
              <Button
                variant="contained"
                className="select-product-modal"
                onClick={onSubmit}
                style={{ marginTop: '11px', marginLeft: '30px' }}
              >
                {t(`Confirm`)}
              </Button>
            </Col>
          </Row>
          {error != '' && <p style={{ color: 'red' }}>{error}</p>}
        </Container>
      </Modal.Body>
    </Modal>
  );
}
